import { Loader } from 'components/Loader';
import { FC, useEffect } from 'react';

interface IProps {
  title?: string;
  subtitle?: string;
  btnNameOne?: string;
  btnNameTwo?: string;
  setOpen?: (value: string) => void;
  onClick: () => void;
  loader?: boolean;
}

export const PopUpAsk: FC<IProps> = ({
  setOpen,
  title,
  subtitle,
  btnNameOne,
  btnNameTwo,
  onClick,
  loader = false,
}) => {
  const height =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  const onClose = () => {
    setOpen?.('');
  };

  // const heightPopup = (): number => {
  // 	return document.querySelector('.authorization-form')!?.clientHeight;
  // };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="blur-wrapper-popup">
      <div style={{ top: height / 2 - 240 / 2 }} className="authorization-form fit-content">
        <p className="form-title">{title}</p>
        <p className="form-subtitle">{subtitle}</p>
        <div className="authorization-form__body">
          <div className="form-submit">
            <button
              disabled={loader}
              onClick={onClick}
              type="button"
              className="button button--248-width "
            >
              {loader ? <Loader height={30} width={30} /> : btnNameOne}
            </button>
          </div>
          <div className="form-submit">
            <button
              onClick={onClose}
              type="button"
              className="button button--gray button--248-width "
            >
              {btnNameTwo}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
